bovoApp.controller('FailOrderController', ['$scope', 'FailOrder', '$location', '$routeParams', '$filter', '$translate', 'ngAudio', '$rootScope',
	function ($scope, FailOrder, $location, $routeParams, $filter, $translate, ngAudio, $rootScope) {
		$scope.deleted = [];
		var successSound = ngAudio.load("sounds/success.mp3");
		var errorSound = ngAudio.load("sounds/error.mp3");

		$scope.order_id = null;
		$scope.type = 'customer';
		$scope.failOrder = {
			orders: [],
			company_customer_id: null,
			customer_group_id: null,
			cargo: null
		}

		$scope.filterData = {
			station_id: [],
			price: '',
			vehicle: [],
			page: 1,
			date: {
				startDate: null,
				endDate: null
			}
		}

		$scope.clearFilter = function (page) {
			$scope.filterData = {
				station_id: [],
				price: '',
				vehicle: [],
				page: 1,
				date: {
					startDate: null,
					endDate: null
				}
			}
			$scope.all();
		}

		$scope.remove = function (index) {
			$scope.failOrder.orders.splice(index, 1);
		}

		$scope.selectAll = function (select) {
			if (select) {
				$scope.deleted = [];
				for (let i = 0; i < $scope.data.failOrders.data.length; i++) {
					$scope.deleted.push($scope.data.failOrders.data[i].id);
				}
			} else {
				$scope.deleted = [];
			}
		};

		$scope.$on('refresh_data', function () {
			$scope.all();
		}, true);

		$scope.$on('new_data', function () {
			$('#newFailOrder').modal('show');
			$scope.new();
		}, true);

		$scope.getPage = function (page) {
			$scope.filterData.page = page;
			$scope.all();
		}

		$scope.all = function () {
			FailOrder.all($scope.filterData).success(function (data, status, headers, config) {
				$scope.data = data;
			});
		}

		$scope.send = function () {
			console.log($scope.type)
			console.log($scope.failOrder.company_customer_id)
			console.log($scope.failOrder.customer_group_id)
			if ($scope.type == 'customer' && !$scope.failOrder.company_customer_id && !$scope.failOrder.customer_group_id) {
				alert('Lütfen müşteri veya müşteri grubu seçiniz!');
				return;
			}
			if ($scope.type == 'cargo' && !$scope.failOrder.cargo) {
				alert('Lütfen taşıyıcı seçiniz!');
				return;
			}

			// Aynı kargo daha önce eklenmişse hata ver
			var alreadyAdded = $scope.failOrder.orders.some(function (o) {
				return String(o.id) === String($scope.order_id);
			});
			if (alreadyAdded) {
				errorSound.play();
				Messenger().post({
					message: "Bu kargo zaten okundu!",
					type: "error"
				});
				$scope.order_id = null;
				return;
			}

			var data = {
				type: $scope.type,
				cargo: $scope.failOrder.cargo,
				order_id: $scope.order_id,
				company_customer_id: $scope.failOrder.company_customer_id,
				customer_group_id: $scope.failOrder.customer_group_id,
			};
			if ($scope.failOrder.id) {
				data.id = $scope.failOrder.id
			}
			FailOrder.addOrder(data).success(function (data, status, headers, config) {
				console.log($scope.type)
				console.log($scope.failOrder.company_customer_id)
				console.log($scope.failOrder.customer_group_id)
				if ($scope.type == 'customer') {
					if ($scope.failOrder.company_customer_id && $scope.failOrder.company_customer_id != 'null') {
						if (data.order.company_customer_id != $scope.failOrder.company_customer_id) {
							errorSound.play()
							Messenger().post({
								message: "Bu Kargo Seçilen Müşteriye Ait Değildir! Sadece seçilen müşteriye ait kargoları ekleyebilirsiniz.",
								type: "error"
							});
							return;
						}
					} else if ($scope.failOrder.customer_group_id && $scope.failOrder.customer_group_id != 'null') {
						if (!data.order.customer.group || (data.order.customer.group && data.order.customer.group.map(i => i.id).indexOf(Number($scope.failOrder.customer_group_id)) < 0)) {
							errorSound.play()
							Messenger().post({
								message: "Bu Kargo Seçilen Müşteriye Ait Değildir! Sadece seçilen müşteriye ait kargoları ekleyebilirsiniz.",
								type: "error"
							});
							return;
						}
					}
					$scope.failOrder.orders.push(data.order)
					$scope.order_id = null;
					successSound.play()
				} else if ($scope.type == 'cargo') {
					if (data.order.work_type.id != $scope.failOrder.cargo.id) {
						errorSound.play()
						Messenger().post({
							message: "Bu Kargo Seçilen Taşıyıcıya Ait Değildir! Sadece seçilen taşıyıcıya ait kargoları ekleyebilirsiniz.",
							type: "error"
						});
						return;
					}
					$scope.failOrder.orders.push(data.order)
					$scope.order_id = null;
					successSound.play()
				}

			}).error(function (data) {
				Messenger().post({
					message: data.message,
					type: "error"
				});
			});
		};

		$scope.init = function () {
			FailOrder.new().success(function (data, status, headers, config) {
				$scope.data = data;
				if ($routeParams.id) {
					$scope.get($routeParams.id);
				}
			});
		}

		$scope.deleteFailDocument = function (id) {
			$scope.deleteDocument(id);
			setTimeout(() => {
				if ($routeParams.id) {
					$scope.get($routeParams.id);
				}
			}, 2000);
		}

		$scope.initApprove = function () {
			if ($routeParams.id) {
				$scope.get($routeParams.id);
			}
		}

		$scope.get = function (id) {
			FailOrder.get(id).success(function (data, status, headers, config) {
				$scope.failOrder = data.failOrder;
				$scope.type = data.failOrder.type
				$scope.failOrder.cargo = data.failOrder.work_type
				$scope.failOrder.company_customer_id = data.failOrder.company_customer_id
				$scope.failOrder.customer_group_id = data.failOrder.customer_group_id
				// $scope.waybill_number = String(data.failOrder.waybill_number)
			});
		}


		$scope.delete = function (type) {
			if (type == 'set') {
				$('#delete').modal('show');
			} else if (type == 'delete') {
				FailOrder.delete($scope.deleted).success(function (data, status, headers, config) {
					Messenger().post('Silindi');
					for (var i = $scope.deleted.length - 1; i >= 0; i--) {
						var index = $scope.data.failOrders.data.indexOf($filter('filter')($scope.data.failOrders.data, {
							id: $scope.deleted[i]
						})[0]);
						if (index > -1)
							$scope.data.failOrders.data.splice(index, 1);
					}
					$scope.deleted = [];
					$('#delete').modal('hide');
				}).error(function (data) {
					Messenger().post({
						message: data.message,
						type: "error"
					});
				});
			}
		}

		$scope.save = function (force) {
			if (!force) {
				var warning = false;
				$scope.failOrder.orders.forEach(element => {
					if (!element.status || (element.status && element.status.value != 'fail' && element.status.value != 'refund')) {
						warning = true;
					}
				});
				if (warning) {
					$('#warning').modal('show');
					return;
				}
			}

			if ($scope.failOrder.id) {
				$scope.update();
			} else {
				$scope.failOrder.company_customer_id = $scope.failOrder.company_customer_id;
				$scope.failOrder.customer_group_id = $scope.failOrder.customer_group_id;
				$scope.failOrder.type = $scope.type;
				// $scope.failOrder.waybill_number = $scope.waybill_number;
				FailOrder.save($scope.failOrder).success(function (data, status, headers, config) {
					$scope.failOrder = data.data;
					$scope.failOrder.company_customer_id = data.data.company_customer_id
					$scope.failOrder.customer_group_id = data.data.customer_group_id
					$('#warning').modal('hide');
					Messenger().post('Kaydedildi');
					setTimeout(() => {
						$location.path('fail-order/create').search('id', data.data.id);
					}, 500);
				}).error(function (data) {
					Messenger().post({
						message: data.message,
						type: "error"
					});
				});
			}
		}

		$scope.update = function () {
			$scope.failOrder.company_customer_id = $scope.failOrder.company_customer_id;
			$scope.failOrder.customer_group_id = $scope.failOrder.customer_group_id;
			FailOrder.update($scope.failOrder).success(function (data, status, headers, config) {
				Messenger().post('Güncellendi');
				$('#warning').modal('hide');
			}).error(function (data) {
				Messenger().post({
					message: data.message,
					type: "error"
				});
			});
		}

		$scope.approve = function () {
			let isExecuted = confirm("İade teslimini onaylıyor musunuz?");
			if (isExecuted) {
				FailOrder.approve($scope.failOrder).success(function (data, status, headers, config) {
					Messenger().post('Güncellendi');
					$scope.failOrderSuccess = true;
				}).error(function (data) {
					Messenger().post({
						message: data.message,
						type: "error"
					});
				});
			}

		}

		$scope.export = function () {
			FailOrder.export($scope.failOrder).success(function (data, status, headers, config) {
				window.location.href = data.url;
			}).error(function (data) {
				Messenger().post({
					message: data.message,
					type: "error"
				});
			});
		}

		$scope.openDetail = function (data) {
			$location.path('fail-order/create').search('id', data.id);
		}

		$scope.print = function (data) {
			window.open('/print-fail-order/' + data.id, '_blank');
		}

		$scope.toggleSelection = function toggleSelection(id) {
			var idx = $scope.deleted.indexOf(id);
			if (idx > -1) {
				$scope.deleted.splice(idx, 1);
			} else {
				$scope.deleted.push(id);
			}
		};

	}
]);